import * as React from "react";

import {
  List,
  Datagrid,
  ListProps,
  TextField,
  FunctionField,
  DateField,
  Button
} from "react-admin";
import { Snackbar } from "@material-ui/core";
import {resendSms} from "./index"
import {PartnerDiscountSmsLogSearch} from './PartnerDiscountSmsLogSearch'

import Pagination from "../Components/Pagination";

const productType: any = {
  SENT: "ارسال شده",
}

export const PartnerDiscountSmsLogList = (props: ListProps): React.ReactElement => {
  const [filterList, setFilterList] = React.useState({
      mobile: { contains: '' }
  });
  const [serverState, setServerState] = React.useState({
    resendSms: {status: "NONE", message: ""}
  })

  const resendSmsLog = async (partnerDiscountUsageId: string) => {
    setServerState({...serverState, resendSms: {...serverState.resendSms, status: 'PENDING'}})
    resendSms(partnerDiscountUsageId).then((res: any) => {
      console.log('resendSms: ', res)
      if(!res.data.err){
        console.log('SUCCESSFUL')
        setServerState({...serverState, resendSms: {message: 'پیامک با موفقیت ارسال شد', status: 'SUCCESSFUL'}})
        document.querySelector('.MuiSnackbarContent-root')?.classList.add('snack-successful')
      }
      else {
        setServerState({...serverState, resendSms: {message: 'خطا در ارسال پیامک', status: 'ERROR'}})
        document.querySelector('.MuiSnackbarContent-root')?.classList.add('snack-error')
      }
    }).catch((e: any) => {
      setServerState({...serverState, resendSms: {message: 'خطا در ارسال پیامک', status: 'ERROR'}})
      document.querySelector('.MuiSnackbarContent-root')?.classList.add('snack-error')
    })
  }

  return (
    <>
    <PartnerDiscountSmsLogSearch filterList={filterList} setFilterList={setFilterList}/>
    <List
      {...props} 
      bulkActionButtons={false}
      title={"لیست تاریخچه ارسال پیامک"}
      perPage={50}
      pagination={<Pagination />}
      filter={filterList}
    >
      <Datagrid>
        <TextField label="موبایل" source="mobile" />
        <FunctionField
          label="وضعیت"
          render={(record: any) => productType[record.status]}
        />
        <TextField label="پیام" source="message" /> 
        <DateField label="تاریخ آخرین تغییر" source="updatedAt" showTime={true} locales="fa-IR" />  
        <FunctionField
          label=""
          render={(record: any) => record.partnerDiscountUsageId ? <Button onClick={() => resendSmsLog(record.partnerDiscountUsageId)} label="ارسال پیامک" color="primary"></Button> : null}
        />        
      </Datagrid>      
    </List>
    <Snackbar
    open={serverState.resendSms.status === 'ERROR' || serverState.resendSms.status === 'SUCCESSFUL' ? true : false}
    onClose={() => {
        setServerState({ ...serverState, resendSms: { ...serverState.resendSms, status: 'NONE' } });            
    }}
    autoHideDuration={1500}
    anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
    message={serverState.resendSms.message}
    style={{ backgroundColor: 'transparent', borderRadius: '12px' }}
  />
    </>
  );
};
